import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

function NavBar() {
  return ( 
    <Navbar fixed="top" bg="dark"  expand="lg" variant="dark">
      <Container>
        <Navbar.Brand href="#home">{"<Leon Albert />"}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-na{vbar-nav" />
        <Navbar.Collapse className="nav-items">
          <Nav>
            <Nav.Link href="#about">About</Nav.Link>
            <Nav.Link href="#skills">Skills</Nav.Link>
            <Nav.Link href="#projects">Projects</Nav.Link>
            <Nav.Link href="#testimonies">Testimonies</Nav.Link>
            <Nav.Link href="#contact">Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;